export default __webpack_public_path__ + "static/emo-c2f55010f21d1ff0416986d8b28c4c9f.webp";